import * as React from 'react';
import type { Product } from '../types/Product';

interface IProductListingProps {
	product: Product;
	qty: number;
	changeQty: React.ChangeEventHandler<HTMLButtonElement>;
	handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
}

export default function ProductListing(props: IProductListingProps): JSX.Element {
	const logo = props.product.vendor.file_exists ? (
		<img
			src={props.product.vendor.logo.small}
			alt={props.product.vendor.name}
			title={props.product.vendor.name}
		/>
	) : <h4>{props.product.vendor.name}</h4>;

	return (
		<div>
			<div className="_vendorInfo">
				<div className="_vendorLogo">
					<a href={'/marketplace/vendors/' + props.product.vendor.id + '/storefront'}>{logo}</a>
				</div>
				<div className="_vendorPrice">
					<p>${props.product.price} / each</p>
					<span>
						<div className="_gradeDesc">
							<p>{props.product.grade.description}</p>
						</div>
						<div className="_priceArrow"><div></div></div>
						Condition: <strong><a style={{ color: '#FF9800' }} href="#">{props.product.grade.label}</a></strong>
					</span>
				</div>
			</div>
			<div className="_vendorCart">
				<label htmlFor="qty">Qty: </label>
				<input
					id="qty"
					type="text"
					size={3}
					maxLength={5}
					value={props.qty}
					className="rnum"
					onChange={props.changeQty}
				/>
				<input
					className="cartbutton"
					type="submit"
					value="Buy Now"
					title="Buy Now"
					onClick={props.handleSubmit}
				/>
			</div>
			<div>
				<p style={{ fontWeight: 'bold' }}>{props.product.qty} in stock</p>
			</div>
		</div>
	);
}